/* Progressive enhancement: the complete catalogue and comparison exist in HTML. */
(() => {
  const catalogue = document.querySelector('[data-device-catalogue]');
  if (!catalogue) return;
  const filters = [...catalogue.querySelectorAll('[data-device-filter]')];
  const cards = [...catalogue.querySelectorAll('[data-device-card]')];
  const input = catalogue.querySelector('[data-device-search]');
  const count = catalogue.querySelector('[data-device-count]');
  const empty = catalogue.querySelector('[data-device-empty]');
  const resets = [...catalogue.querySelectorAll('[data-device-reset]')];
  const params = new URLSearchParams(location.search);
  const allowed = new Set(filters.map(button => button.dataset.deviceFilter));
  let goal = allowed.has(params.get('goal')) ? params.get('goal') : 'all';
  const normalize = value => value.normalize('NFKC').toLocaleLowerCase().trim();
  if (params.has('q')) input.value = params.get('q');
  function update(syncUrl = true) {
    const search = normalize(input.value);
    let visible = 0;
    cards.forEach(card => {
      const modeMatches = goal === 'all' || card.dataset.modes.split(' ').includes(goal);
      const searchMatches = normalize(card.dataset.search).includes(search);
      card.hidden = !(modeMatches && searchMatches);
      if (!card.hidden) visible += 1;
    });
    filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.deviceFilter === goal)));
    count.textContent = (visible === 1 ? count.dataset.singleTemplate : count.dataset.countTemplate).replace('{count}', visible);
    empty.hidden = visible !== 0;
    resets.forEach(button => { if (!button.closest('[data-device-empty]')) button.hidden = goal === 'all' && !search; });
    if (syncUrl) {
      const url = new URL(location.href);
      goal === 'all' ? url.searchParams.delete('goal') : url.searchParams.set('goal', goal);
      search ? url.searchParams.set('q', input.value.trim()) : url.searchParams.delete('q');
      history.replaceState(null, '', url.pathname + url.search + url.hash);
    }
  }
  filters.forEach(button => button.addEventListener('click', () => { goal = button.dataset.deviceFilter; update(); }));
  input.addEventListener('input', () => update());
  resets.forEach(button => button.addEventListener('click', () => {
    const wasInEmptyState = !!button.closest('[data-device-empty]');
    goal = 'all'; input.value = ''; update();
    if (wasInEmptyState) filters[0].focus();
  }));
  addEventListener('popstate', () => {
    const current = new URLSearchParams(location.search);
    goal = allowed.has(current.get('goal')) ? current.get('goal') : 'all';
    input.value = current.get('q') || '';
    update(false);
  });
  update(false);
})();
